import { createSelector } from 'reselect'
import { Map } from 'immutable'

export const getGallery = (state: Map<any, any>) => state.get('gallery')

export const getGalleryPending = createSelector(getGallery, gallery => gallery.get('pending'))

export const getGallerySearchBy = createSelector(getGallery, gallery => gallery.get('search'))

export const getGalleryImages = createSelector(getGallery, gallery => gallery.get('images'))

export const getGalleryActivitiesImages = createSelector(getGalleryImages, images =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('activities') !== -1)
)

export const getGalleryOrganizationsImages = createSelector(getGalleryImages, images =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('organizations') !== -1)
)

export const getGalleryProtracksImages = createSelector(getGalleryImages, images =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('protracks') !== -1)
)

export const getGalleryEmailsImages = createSelector(getGalleryImages, images =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('emails') !== -1)
)

export const getGalleryPublicImages = createSelector(getGalleryImages, images =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('public') !== -1)
)

export const getGallerySprintsImages = createSelector(getGalleryImages, images =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('sprints') !== -1)
)

export const getSearchAtActivitiesImages = createSelector(
  getGalleryActivitiesImages,
  getGallerySearchBy,
  (images, filterBy) => {
    return filterBy && filterBy.length >= 1
      ? images.filter((image: Map<string, any>) => {
          const usagePlaces = image.get('usagePlaces')
          const fileName = image.get('fileName')
          const placesToSearch = `${fileName}__${usagePlaces}`.toLowerCase()
          return (
            // search full word (domain/public name) at url which was type before space
            placesToSearch.search(filterBy.toLowerCase().split(' ')[0]) !== -1 &&
            // search character at url which was type after space
            placesToSearch.search(new RegExp(filterBy.toLowerCase().split(' ')[1], 'i')) !== -1
          )
        })
      : images
  }
)

export const getGalleryLoaded = createSelector(getGallery, gallery => gallery.get('loaded'))

export const getImageForReplace = createSelector(getGallery, gallery => gallery.get('imageForReplace'))

export const getIsButtonDisable = createSelector(getGallery, gallery => gallery.get('isButtonDisable'))

export const getImageToDelete = createSelector(getGallery, gallery => gallery.get('imageToDelete'))

export const getImageUsagePlaces = createSelector([getGalleryActivitiesImages, getImageToDelete], (gallery, image) =>
  gallery.find((item: Map<string, any>) => item.get('url') === image).get('usagePlaces')
)
